import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { UserService } from '../userService';
import { ListUserDto } from '../dto/listUserDto';
import { RestResponse } from '../../../shared/RestResponse';
import { Pagination } from '../../../shared/Pagination';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.html',
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, InputTextModule, TagModule, TooltipModule, ConfirmDialogModule]
})
export class ListUserComponent implements OnInit {
  users: ListUserDto[] = [];
  search: string = '';
  searchTerm: string = '';


  constructor(
    private userService: UserService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers(): void {
    this.userService.list(this.search, 1, null, null, [3]).subscribe((response: RestResponse<ListUserDto[]>) => {
      this.users = response.data;
    });
  }

  onSearchChange(search: string): void {
    this.search = search;
    this.loadUsers();
  }

  editUser(id: number): void {
    this.router.navigate(['/users/edit', id]);
  }

  deleteUser(id: number): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir este usuário?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.userService.delete(id).subscribe({
          next: () => {
            this.loadUsers();
          },
          error: (error) => {
            console.error('Erro ao excluir usuário:', error);
          }
        });
      }
    });
  }

  navigateToCreate(): void {
    this.router.navigate(['/users/create']);
  }
}
